export default "__VITE_ASSET__av7ETsCp__"